import { Divider, Radio, Table } from 'antd';
// import type { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { DataTypeLogistic } from '../../interface';

interface Props {
  getWarehouseDetail: Function;
  warehouseData: any;
  totalWarehouse: number;
  loading: boolean;
  //sellerListDetail:
  //warehouse
  selectedWarehouse: React.Key[];
  setSelectedWarehouse: React.Dispatch<React.SetStateAction<React.Key[]>>;
  handleChangePageLogistic: Function;
}

const columns = [
  {
    title: 'No',
    dataIndex: 'no',
    key: 'no'
  },
  {
    title: '물류센터명',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '물류센터 ID',
    dataIndex: 'email',
    key: 'email'
  },
  {
    title: '국가',
    dataIndex: 'country',
    key: 'country'
  },
  {
    title: '계약 상품',
    dataIndex: 'productName',
    key: 'productName'
  }
];

const LogisticTable = ({
  warehouseData,
  totalWarehouse,
  loading,
  selectedWarehouse,
  setSelectedWarehouse,
  handleChangePageLogistic
}: Props) => {
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedWarehouse(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedWarehouse,
    onChange: onSelectChange
  };

  return (
    <div>
      <Table
        className="busk-table"
        rowSelection={rowSelection}
        loading={loading}
        columns={columns}
        dataSource={warehouseData}
        pagination={{
          pageSize: 10,
          total: totalWarehouse,
          onChange: (newPage) => {
            handleChangePageLogistic(newPage);
          }
        }}
      />
    </div>
  );
};

export default LogisticTable;
